import type { CustodyCase, HistoryKey } from '../types/case';

export interface CitizenNotification { pcr: string; at: string; title: string; body: string; tone: 'navy' | 'green' | 'danger' | 'warning'; }

const MAP: Partial<Record<HistoryKey, { title: string; tone: CitizenNotification['tone'] }>> = {
  created: { title: 'PCR তৈরি হয়েছে', tone: 'navy' },
  received: { title: 'যানবাহন ডাম্পিং স্টেশনে পৌঁছেছে', tone: 'navy' },
  docs_returned: { title: 'কাগজপত্রে ঘাটতি — সংশোধন প্রয়োজন', tone: 'danger' },
  paid: { title: 'পেমেন্ট নিশ্চিত হয়েছে', tone: 'green' },
  office_payment: { title: 'অফিসে পেমেন্ট লিপিবদ্ধ হয়েছে', tone: 'green' },
  verified: { title: 'কাগজপত্র যাচাই সম্পন্ন', tone: 'green' },
  forwarded: { title: 'অনুমোদন অপেক্ষমাণ', tone: 'warning' },
  issued: { title: 'অবমুক্তি পত্র প্রস্তুত', tone: 'green' },
  released: { title: 'যানবাহন অবমুক্ত হয়েছে', tone: 'green' },
};

export function buildNotifications(cases: CustodyCase[]): CitizenNotification[] {
  return cases
    .flatMap((c) =>
      c.history
        .filter((h) => MAP[h.key])
        .map((h) => ({ pcr: c.pcr, at: h.at, title: MAP[h.key]!.title, body: h.note ? `${h.action} — ${h.note}` : h.action, tone: MAP[h.key]!.tone })),
    )
    .sort((a, b) => b.at.localeCompare(a.at));
}
